import { create } from "zustand";

interface BidListingRow {
  sno: number;
  sourceCity: string;
  destinationCity: string;
  distanceKm: number;
  vehicleType: string;
  currency: string;
  total: string | number;
  minimum_charge: number;
  toll: number;
  parking: number;
  da: number;
  minDistance: number;
  perKmCharge: number;
  fromDate: string;
  toDate: string;
  startTime: string;
  endTime: string;
  status: string;
  action: string;
  route_id: number;
  ip?: string;
  city_id?: number;
  modified_by?: string;
  vehicle_type_id?: number;
  city_distance_id?: number;
  via_city?: string;
  source_city_id?: number;
  base_vehicle_id?: number;
  luggage_carrier?: string;
}

interface BidFormStore {
  bidForm: string;
  setBidForm: (feature: string | ((prev: string) => string)) => void;

  bidData?: BidListingRow;
  setBidData: (data?: BidListingRow) => void;
};

export const useBidFormStore = create<BidFormStore>((set) => ({
  bidForm: "searchBid",
  setBidForm: (feature) =>
    set((state) => ({
      bidForm: typeof feature === "function" ? feature(state.bidForm) : feature,
    })),

  bidData: undefined,
  setBidData: (data) => set({ bidData: data }),
}));
